/**
 * Registry mapping a documentId (see src/config/legal.js) to its in-repo content blocks.
 */
import termsOfService from './termsOfService';
import privacyPolicy from './privacyPolicy';
import cancellationPolicy from './cancellationPolicy';
import providerAgreement from './providerAgreement';
import cookiePolicy from './cookiePolicy';
import securityPolicy from './securityPolicy';
import about from './about';
import contactUs from './contactUs';

const LEGAL_CONTENT = {
  termsOfService,
  privacyPolicy,
  cancellationPolicy,
  providerAgreement,
  cookiePolicy,
  securityPolicy,
  about,
  contactUs,
};

export default LEGAL_CONTENT;
